import { createFileRoute } from "@tanstack/react-router";
import UnderConstruction from "@/components/common/UnderConstruction";

export const Route = createFileRoute("/_app/ventes/crm/$id/edit")({
  staticData: {
    title: "Modifier contact",
    showInBreadcrumb: true,
  },
  component: UnderConstruction,
});
